import ability from './ability'

//console.log('ability', to => to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource)))
export const customNavigate = to => {

    const userData = JSON.parse(localStorage.getItem('userData'))

    console.log('userData.ability', userData.ability)
    
    console.log(to.matched.some(route => ability.can(route.meta.action || 'read', 5555)))

    console.log('to.meta.resource', to.meta.menu)
}

export const canNavigate = to => to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource))

export const _ = undefined
